<template>
  <div class="sppt thumb-example" ref="content">
    <swiper
      class="swiper gallery-top swiper-no-swiping"
      :options="swiperOptionTop"
      ref="swiperTop"
      v-if="spptList.length>0"
    >
      <swiper-slide class="slide" v-for="(item,key,index) in spptList" :key="index">
        <img
          :class="slideimg"
          :src="item.src"
          ref="changebig"
          @click="showSwiperThumbs"
          draggable="false"
        />
      </swiper-slide>
      <div class="swiper-button-next swiper-button-white" slot="button-next" ref="next"></div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev" ref="prev"></div>
    </swiper>

    <div>
      <div class="btnbox">
        <div class="kong"></div>
        <div class="btncenter">
          <i class="el-icon-caret-left" @click="btnclickPrev"></i>
          <span class="ye">{{spptIds}}</span>
          <span class="allye">{{'/'}}</span>
          <span class="allye">{{spptList.length}}</span>
          <i class="el-icon-caret-right" @click="btnclickNext"></i>
        </div>
        <div class="btnright">
          <i @click="toggleFullscreen" class="el-icon-full-screen" v-show="is"></i>
          <i @click="toggleFullscreen" class="el-icon-copy-document" v-show="!is"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptionTop: {
        loop: false,
        // loopedSlides: 10, //在loop模式下使用slidesPerview:'auto'，还需使用该参数设置所要用到的loop个数
        // spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: false,
        // loopedSlides: 10, //循环的幻灯片应该相同
        spaceBetween: 10,
        // centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
        slidesPerView: 5,
        touchRatio: 0, //触摸距离与slide滑动距离的比率。
        slideToClickedSlide: true, //设置为true则点击slide会过渡到这个slide。
      },
      totalPage: 0,
      //图片数据
      spptList: [
        {
          id: 1,
          src: 'https://edu-image.nosdn.127.net/9BFE45E8A8C8AA6A5233AA51A91A9EDF.png?imageView&thumbnail=510y288&quality=100',
        },
        {
          id: 2,
          src: 'https://img-ph-mirror.nosdn.127.net/tYhzuDVilzlDOo2bEyH_Qg==/6608226511143817333.jpg',
        },
        {
          id: 3,
          src: 'https://edu-image.nosdn.127.net/54BB735C0C79D653219EBEF3D9DC9A4D.jpg?imageView&thumbnail=426y240&quality=100',
        },
        {
          id: 4,
          src: 'https://edu-image.nosdn.127.net/3A5D82829208F115DD1EFA052334A4A9.png?imageView&thumbnail=426y240&quality=100',
        },
        { id: 5, src: require('@/assets/sppt/2.jpg') },
        { id: 1, src: require('@/assets/sppt/1.jpg') },
        { id: 2, src: require('@/assets/sppt/2.jpg') },
        { id: 3, src: require('@/assets/sppt/3.jpg') },
        { id: 4, src: require('@/assets/sppt/3.jpg') },
        { id: 5, src: require('@/assets/sppt/2.jpg') },
      ],
      slideimg: 'slide-img',
      flag: 0,
      is: true,
      spptId: 1,
      url: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
    };
  },
  methods: {
    pageLoaded(e) {
      this.curPageNum = e;
    },
    //页数更改
    btnSwiperId(number) {
      // console.log(number + 1);
      this.spptId = number + 1;
    },
    //触发swiper切换页面 下一页
    btnclickNext() {
      this.$refs.next.click();
      // console.log((this.spptId += 1));
    },

    // 上一页
    btnclickPrev() {
      this.$refs.prev.click();
      // console.log((this.spptId -= 1));
    },

    //显示和隐藏SwiperThumbs
    showSwiperThumbs() {
      this.showSwiper = false;
    },
    //判断是否全屏
    toggleFullscreen() {
      this.is = !this.is;
      // console.log(this.is)
      this.flag++;
      this.flag % 2 == 0
        ? this.outFullCreeen(document)
        : this.FullCreeen(document.documentElement);
    },
    // 进入全屏的方法
    FullCreeen() {
      this.showSwiper = false;
      let el = this.$refs.content;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      // Element.requestFullscreen() 此方法用于发出异步请求使元素进入全屏模式。
      // 调用此API并不能保证元素一定能够进入全屏模式。如果元素被允许进入全屏幕模式，
      // document对象会收到一个fullscreenchange事件，通知调用者当前元素已经进入全屏模式。如果全屏请求不被许可，则会收到一个fullscreenerror事件。
      if (typeof rfs != 'undefined' && rfs) {
        rfs.call(el);
      } else if (typeof window.ActiveXObject != 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell');
        if (wscript != null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    //退出全屏的方法
    outFullCreeen(element) {
      let el = element;
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      if (typeof cfs != 'undefined' && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell');
        if (wscript != null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
  },
  computed: {
    spptIds() {
      if (this.spptId > 0 && this.spptId <= this.spptList.length) {
        return (this.spptId = this.spptId);
      } else if (this.spptId > this.spptList.length) {
        return (this.spptId = this.spptList.length);
      } else if (this.spptId <= 0) {
        return (this.spptId = 1);
      }
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      //   console.log(this)
      // const swiperTop = this.$refs.swiperTop.$el.swiper;
      // const swiperThumbs = this.$refs.swiperThumbs.$el.swiper;
      // swiperTop.controller.control = swiperThumbs;
      // swiperThumbs.controller.control = swiperTop;
    });
  },
};
</script>

<style lang="scss" scoped>
.sppt {
  background-color: gainsboro;
  height: 100%;
  width: 1200px;
}
.el-carousel__item {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.swiper {
  position: relative;
  &.gallery-top {
    height: 94%;
    width: 100%;
    .swiper-button-white {
      visibility: hidden;
    }
  }
  &.gallery-thumbs {
    height: 12%;
    box-sizing: border-box;
    padding: 10px 0;
    overflow: hidden;
    margin-top: -92px;
    width: 100%;
    padding-right: 600px;
    background-color: #5e5e5e7e;
  }
  &.gallery-thumbs .swiper-slide {
    width: 128px;
    height: 72px;
    opacity: 0.6;
  }
  &.gallery-thumbs .swiper-slide-active {
    background-color: white;
    opacity: 1;
  }
}
.swiper-slide {
  background-color: white;
  color: black;
}
.slide-img {
  height: 100%;
  width: 100%;
}
.slide-img.add {
  height: 120%;
  width: 120%;
}
.slide-img2 {
  height: 100%;
  width: 100%;
  position: relative;
}
.number {
  position: absolute;
  background-color: #717371;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  bottom: 0;
  right: 0;
  text-align: center;
  line-height: 20px;
  color: #bebec1;
}

.btnbox {
  height: 32px;
  background-color: #212228;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  .btncenter,
  .btnright {
    display: flex;
    align-items: center;
    .ye {
      color: white;
      width: 36px;
      background: #3e3f49;
      border-radius: 10px;
      text-align: center;
      height: 23px;
      line-height: 23px;
      cursor: pointer;
    }
    .allye {
      color: white;
      text-align: center;
      padding-left: 5px;
      cursor: pointer;
    }
    i {
      color: white;
      font-size: 20px;
      padding: 0 10px;
      cursor: pointer;
    }
  }
}
.thumbsbox {
  background-color: #5e5e5e;
}

.swiper.gallery-thumbs .swiper-slide-active {
  border: 2px solid #1e97ff !important;
}
.swiper.gallery-thumbs {
  margin-top: -97px !important;
  height: 18% !important;
  padding-right: 0 !important;
}
</style>
